export const gender = [
  'male',
  'female'
];
export const employmentStatus =  [
  'employed',
  'self employed',
  'unemployed',
  'retired',
  'student',
  //'other',
  //'unknown'
];
export const maritalStatus = [
  'single',
  'separated',
  'divorced',
  'widower',
  'married',
  'civil_union'
];
export const maritalRegime = [
  'share',
  'separation_of_property',
  'community_of_gains',
];
export const currentAmountInvestedInPensionPlans = [
  '0',
  '<10000',
  '<100000',
  '>100000'
];
export const publicCharge = [
  'no_public_charge',
  'public_charge',
  'familiar_public_charge',
  'relative_public_charge',
  //'unknown'
];
export const publicChargeKind = [
  'politician',
  'official',
  'government',
  'ambassador',
  'other',
  //'unknown'
];
export const incomeOrigin = [
  'principal',
  'other',
  'justified',
  'grant',
  'pension',
  'unemployment',
  'others',
  'third',
  //'unknown'
];
export const incomeVolume = [
  '<15000',
  '<30000',
  '<45000',
  '<60000',
  '<75000',
  '<100000',
  '>100000',
  //'unknown'
];
export const fundsOrigin = [
  'savings',
  'inheritance/donation',
  'activity_fees',
  'prizes',
  'investment_profit'
];
